import { IGroup } from "./access";
import { IBranch } from "./branch";
import { ApiResponse } from "./store";
import { ISubModule } from "./tenant";

// INTERFACES
export interface IPractitioner {
  id: string;
  email: string;
  phone: string;
  firstname: string;
  lastname: string;
  gender?: string;
  practitionerField: string;
  practitionerType: PractitionerType;
  practitionerLicenseURL?: string | null;
  status: StaffStatus;
  licenseExpiry?: string | null;
  statusComment?: string | null;
  branchID?: number | null;
  groups: IGroup[];
  createdAt: string;
  updatedAt: string;
}

export interface IAddStaffForm {
  firstname: string;
  lastname: string;
  email: string;
  phone: string
  gender: string;
  category: string | number;
  branch: string | number;
}

export interface IAddStaffPayload {
  Firstname: string;
  Lastname: string;
  Email: string;
  Phone: string;
  Gender: string;
  PractitionerType: string;
  PractitionerField: string;
  BranchID: number;
  GroupID: number[];
}

export interface IEditStaffPayload {
  PractitionerID: string;
  Firstname: string;
  Lastname: string;
  Email: string;
  Phone: string;
  Gender: string;
  PractitionerType: string;
  BranchID: number;
}

export interface IUpdateUserGroupsPayload {
  PractitionerID: string;
  GroupID: number[];
}

export interface IStaffStatusUpdatePayload {
  PractitionerID: string;
  FlagID: StaffUpdateStatus;
}

export interface IResendInviteLinkPayload {
  email: string;
}

// Identity Store Interfaces
export interface IIdentityState {
  // General Loading States
  loading: boolean;
  isLoadingMore: boolean;
  saving: boolean;
  groupsLoading: boolean;
  groupLoading: boolean;
  permsLoading: boolean;
  getSubModulesPermsLoading: boolean;
  subModulesLoading: boolean;
  staffStatusUpdateLoading: boolean;
  createUser: boolean;
  editUser: boolean;
  resendInvite: boolean;
  
  // Staffs Data
  staffsData: IPractitioner[];
  staffsDataSuccess: boolean;
  staffsDataMsg: string | null;
  staffsTotalCount: number;
  staffsResponse: ApiResponse<IPractitioner[]> | null;

  // User Operations
  saveUserInfo: string | null;
  saveUserSuccess: boolean;
  staffStatusValue: any | null;
  staffStatusUpdateSuccess: boolean;
  staffStatusUpdateMsg: string | null;
  editUserSuccess: boolean;
  editUserMsg: string | null;
  resendInviteLinkSuccess: boolean;
  resendInviteLinkMsg: string | null;
  
  // Group Operations
  createGroupSuccess: boolean;
  createGroupMsg: string | null;
  groupsData: IGroup[];
  getGroupsSuccess: boolean;
  getGroupsMsg: string | null;
  groupDetails: IGroup | null;
  groupDetailsSuccess: boolean;
  groupDetailsMsg: string | null;
  deleteGroupSuccess: boolean;
  deleteGroupMsg: string | null;
  editGroupNameSuccess: boolean;
  editGroupNameMsg: string | null;
  
  // Permissions Operations
  groupPermsData: any | null;
  groupPermsSuccess: boolean;
  groupPermsMsg: string | null;
  addGroupPermsSuccess: boolean;
  addGroupPermsMsg: string | null;
  removeGroupPermsSuccess: boolean;
  removeGroupPermsMsg: string | null;
  getSubModulesPermsData: any | null;
  getSubModulesPermsSuccess: boolean;
  
  // SubModules Data
  subModulesData: ISubModule[];
  subModulesSuccess: boolean;
  subModulesMsg: string | null;
  
  // User/Group Management
  addUserToGroupSuccess: boolean;
  addUserToGroupMsg: string | null;
  removeUserFromGroupLoading: boolean;
  removeUserFromGroupSuccess: boolean;
  removeUserFromGroupMsg: string | null;
  
  // Branch Management
  branchListLoading: boolean;
  branchList: IBranch[];
  branchListSuccess: boolean;
  branchListMsg: string;
  branchTotalCount: number;
  createBranchLoading: boolean;
  createBranchSuccess: boolean;
  createBranchMsg: string | null;
  createBranch: IBranch | null;
  updateBranchLoading: boolean;
  updateBranchSuccess: boolean;
  updateBranchMsg: string | null;
  branchStatusLoading: boolean;
  branchStatusSuccess: boolean;
  branchStatusMsg: string | null;
  removeMemberLoading: boolean;
  removeMemberSuccess: boolean;
  removeMemberMsg: string | null;
  addModulesLoading: boolean;
  addModulesSuccess: boolean;
  addModulesMsg: string | null;
}

// ENUMS
export enum PractitionerType {
  MEDICAL_PRACTITIONER = "MedicalPractitioner",
  NON_MEDICAL_PRACTITIONER = "NonMedicalPractitioner",
}

export enum StaffUpdateStatus {
  VERIFIED = 0,
  REJECTED = 1,
  SUSPENDED = 2,
}

export enum StaffStatus {
  VERIFIED = "VERIFIED",
  UNVERIFIED = "UNVERIFIED",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  SUSPENDED = "SUSPENDED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
  ONHOLD = "ONHOLD",
  EXPIRED = "EXPIRED",
  INVITED = "INVITED",
}

export enum StaffStatusQueryKey {
  INACTIVE = 0,
  PENDING = 1,
  VERIFIED = 2,
  REJECTED = 3,
  EXPIRED = 4,
  INVITED = 6,
  SUSPENDED = 7,
  ALL = 8
}